import { AxiosResponse } from "axios";

import api from "services/api";

import serveRequestErrors from "common/serve-request-errors";

import { SelectOption } from "dto/components/app-select-input-dto";
import ErrorResponseDto from "dto/services/error-response-dto";

const getLanguageListing = async (): Promise<AxiosResponse<{ content: SelectOption[] }>> => {
	let response = null;

	let errorMessage = "";

	try {
		const res = await api.get.dropdown.retrieveCategory("LANGUAGE", { page: 0, size: 99 });

		const content = res.data.data.list.content.map((o: SelectOption) => ({ label: o.name, value: o.lang }));

		response = { ...res, data: { ...res.data, content: content } };
	} catch (error) {
		const err = error as Error | ErrorResponseDto;
		serveRequestErrors(err);
	}

	if (response) return response;

	throw errorMessage;
};

export default getLanguageListing;
